import * as React from "react";

import SettingsBackupRestoreTwoToneIcon from "@material-ui/icons/SettingsBackupRestoreTwoTone";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router";
import { compose } from "recompose";
import CardList from "~/components/CustomerSupport/CardList";
import Topic from "~/components/CustomerSupport/Topic";
import Questions from "~/components/FAQ/Questions";
import QuestionsHeader from "~/components/FAQ/QuestionsHeader";
import TopicSelector from "~/components/FAQ/TopicSelector";
import { ITopic } from "~/components/FAQ/types";
import { shopConfig } from "~/helpers/shopConfig";
import { StyledCard as Card } from "~/layouts/StyledCard";

interface IParams {
  topic: string;
  question: string;
}

class FAQContainer extends React.Component<
  WithTranslation & RouteComponentProps<IParams>
> {
  public render() {
    const {
      t,
      match: {
        params: { topic, question }
      }
    } = this.props;

    const topics: ITopic[] = t("topics", {
      returnObjects: true,
      ...shopConfig
    });

    if (!topics) {
      return null;
    }

    const currentTopic = topics.find(({ key }) => key === topic);

    return (
      <React.Fragment>
        {currentTopic && (
          <CardList>
            <QuestionsHeader title={currentTopic.title} />

            <TopicSelector
              placeholder={t("selectTopic")}
              value={topic}
              topics={topics}
              onChange={this.handleTopicChange}
            />

            <Questions
              onQuestionChange={this.handleQuestionChange}
              openQuestionKey={question}
              questions={currentTopic.questions}
            />

            {currentTopic.key === "returns" && (
              <Card
                interactive={true}
                onClick={this.handleReturnsFallbackClick}
              >
                <Topic
                  title={t("returnsFallback")}
                  description={null}
                  icon={SettingsBackupRestoreTwoToneIcon}
                  chevron={true}
                />
              </Card>
            )}
          </CardList>
        )}
      </React.Fragment>
    );
  }

  private handleTopicChange = (topic: string) => {
    switch (topic) {
      case "b2b":
        this.props.history.push({ pathname: "/b2b" });
        break;
      case "copyright":
        (window as any).location.pathname = "/pages/report_product";
        break;
      case "giftcard":
        this.props.history.push({ pathname: "/giftcard" });
        break;
      default:
        this.props.history.push(`/faq/${topic}`);
    }
  };

  private handleQuestionChange = (question: string) => {
    const { topic } = this.props.match.params;

    this.props.history.push(
      question ? `/faq/${topic}/${question}` : `/faq/${topic}`
    );
  };

  private handleReturnsFallbackClick = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    event.preventDefault();

    this.props.history.push("/rma/request");
  };
}

export default compose(
  withTranslation("faq"),
  withRouter
)(FAQContainer);



// WEBPACK FOOTER //
// ./src/containers/FAQ/FAQContainer.tsx